<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2a"><a id="page_ix"></a><img alt="image" src="images/contents.jpg"/></h2>
<p class="toc-chaptert"><a class="nounder" href="#/xhtml/chapter1#ch1">1 Idiots Rule</a></p>
<p class="toc-chapter"><a class="nounder" href="#/xhtml/chapter2#ch2">2 Communist Daughter</a></p>
<p class="toc-chapter"><span class="nounder" href="#/xhtml/chapter3#ch3" title="Link target outside of Sample">3 Someday you will Be Loved</span></p>
<p class="toc-chapter"><span class="nounder" href="#/xhtml/chapter4#ch4" title="Link target outside of Sample">4 Wake Up</span></p>
<p class="toc-chapter"><span class="nounder" href="#/xhtml/chapter5#ch5" title="Link target outside of Sample">5 Only Shallow</span></p>
<p class="toc-chapter"><span class="nounder" href="#/xhtml/chapter6#ch6" title="Link target outside of Sample">6 How High the Moon</span></p>
<p class="toc-chapter"><span class="nounder" href="#/xhtml/chapter7#ch7" title="Link target outside of Sample">7 I Just Wanna Get Along</span></p>
<p class="toc-chapter"><span class="nounder" href="#/xhtml/chapter8#ch8" title="Link target outside of Sample">8 Monkey Gone to Heaven</span></p>
<p class="toc-chapter"><span class="nounder" href="#/xhtml/chapter9#ch9" title="Link target outside of Sample">9 Caring Is Creepy</span></p>
<p class="toc-chapter"><span class="nounder" href="#/xhtml/chapter10#ch10" title="Link target outside of Sample">10 Heaven’t Got a Clue</span></p>
<p class="toc-chapter"><a id="page_x"></a><span class="nounder" href="#/xhtml/chapter11#ch11" title="Link target outside of Sample">11 Yerself Is Steam</span></p>
<p class="toc-chapter"><span class="nounder" href="#/xhtml/chapter12#ch12" title="Link target outside of Sample">12 Taste the Pain</span></p>
<p class="toc-chapter"><span class="nounder" href="#/xhtml/chapter13#ch13" title="Link target outside of Sample">13 Addicted to Fame</span></p>
<p class="toc-chapter"><span class="nounder" href="#/xhtml/chapter14#ch14" title="Link target outside of Sample">14 Everything in Its Right Place</span></p>
<p class="toc-chapter"><span class="nounder" href="#/xhtml/chapter15#ch15" title="Link target outside of Sample">15 Sins of the Father</span></p>
<p class="toc-chapter"><span class="nounder" href="#/xhtml/chapter16#ch16" title="Link target outside of Sample">16 I Hate Rock ’n’ Roll</span></p>
<p class="toc-chapter"><span class="nounder" href="#/xhtml/chapter17#ch17" title="Link target outside of Sample">17 The Moon and Antarctica</span></p>
<p class="toc-chapter"><span class="nounder" href="#/xhtml/chapter18#ch18" title="Link target outside of Sample">18 So Far I Have Not Found a Science</span></p>
<p class="toc-back"><span class="nounder" href="#/xhtml/sammysrock#sam" title="Link target outside of Sample">Sammy’s Rock and Jazz Mashup Playlist</span></p>
<p class="toc-back"><span class="nounder" href="#/xhtml/acknowledgments#ack" title="Link target outside of Sample">Acknowledgments</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?74877273